"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enterprisePalette = exports.palette = void 0;
var palette_1 = require("../../shared/palette");
exports.palette = {
    primary: {
        '300': '#E5E9EE',
        '500': '#002855',
        '700': '#001C3C',
    },
    secondary: {
        '300': '#E5EDF8',
        '500': '#004BB9',
        '700': '#003582',
    },
    tertiary: {
        '300': '#E5EDF8',
        '500': '#004BB9',
        '700': '#003582',
    },
    neutrals: __assign({}, palette_1.commonNeutrals),
    text: __assign({}, palette_1.commonTextColors),
    accent01: __assign({}, palette_1.commonAccent01),
    accent02: __assign({}, palette_1.commonAccent02),
    success: __assign({}, palette_1.commonSuccess),
    error: __assign({}, palette_1.commonError),
    warning: __assign({}, palette_1.commonWarning),
    info: __assign({}, palette_1.commonInfo),
    background: __assign(__assign({}, palette_1.commonBackgroundColors), palette_1.commonGradients),
};
exports.enterprisePalette = {
    primary: {
        light: exports.palette.primary[300],
        main: exports.palette.primary[500],
        dark: exports.palette.primary[700],
    },
    secondary: {
        light: exports.palette.secondary[300],
        main: exports.palette.secondary[500],
        dark: exports.palette.secondary[700],
    },
    tertiary: {
        light: exports.palette.tertiary[300],
        main: exports.palette.tertiary[500],
        dark: exports.palette.tertiary[700],
    },
    neutrals: {
        white: exports.palette.neutrals.white,
        neutral: exports.palette.neutrals[100],
        primary: exports.palette.neutrals[300],
        disabled: exports.palette.neutrals[700],
        tertiary: exports.palette.neutrals[800],
        secondary: exports.palette.neutrals[900],
    },
    text: {
        primary: exports.palette.text.primary,
        secondary: exports.palette.text.secondary,
        tertiary: exports.palette.text.tertiary,
        light: exports.palette.text.light,
        disabled: exports.palette.text.disabled,
        interactive: exports.palette.text.interactive,
    },
    accent01: {
        light: exports.palette.accent01[300],
        main: exports.palette.accent01[500],
        dark: exports.palette.accent01[700],
    },
    accent02: {
        light: exports.palette.accent02[300],
        main: exports.palette.accent02[500],
        dark: exports.palette.accent02[700],
    },
    success: {
        light: exports.palette.success[300],
        main: exports.palette.success[500],
        dark: exports.palette.success[700],
    },
    error: {
        light: exports.palette.error[300],
        main: exports.palette.error[500],
        dark: exports.palette.error[700],
    },
    warning: {
        light: exports.palette.warning[300],
        main: exports.palette.warning[500],
        dark: exports.palette.warning[700],
    },
    info: {
        light: exports.palette.info[300],
        main: exports.palette.info[500],
        dark: exports.palette.info[700],
    },
    backgrounds: __assign({}, exports.palette.background),
};
